import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import useTableInstance from "hooks/useTableInstance";
import Pagination from "components/Common/Pagination/index";
import TableContainer from "./TableContainer";
import "../../../styles/components/table.scss";
import DragTableContainer from "./DraggableTable";

function Table(props) {
  const {
    data: tableData,
    isLoading,
    tableColumns,
    TableColumnFilter,
    enableSorting = false,
    currentPage,
    disablePrev,
    disableNext,
    disableFirst,
    disableLast,
    totalPages,
    loadNextPage,
    loadPreviousPage,
    loadFirstPage,
    loadLastPage,
    totalRecords,
    showPagination = true,
    getRowProps = () => ({}),
    onRowsReordered,
    isPatientReportColor = false,
    showPaymentModeFooter = false,
    showColumns = 5,
  } = props;

  const location = useLocation();

  const defaultColumn = useMemo(
    () => ({
      Filter: TableColumnFilter,
    }),
    [TableColumnFilter]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    paginationPageRows,
    prepareRow,
  } = useTableInstance(tableColumns, tableData, defaultColumn, enableSorting);

  return (
    <>
      {location.pathname.includes("investigation-sequence") ? (
        <>
          <DragTableContainer
            getRowProps={getRowProps}
            headerGroups={headerGroups}
            getTableBodyProps={getTableBodyProps}
            rows={paginationPageRows}
            getTableProps={getTableProps}
            prepareRow={prepareRow}
            isLoading={isLoading}
            totalRecords={totalRecords}
            tableData={tableData}
            onRowsReordered={onRowsReordered}
          />
          {tableData.length !== 0 && showPagination && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              loadPreviousPage={loadPreviousPage}
              loadNextPage={loadNextPage}
              disablePrev={disablePrev}
              disableNext={disableNext}
            />
          )}
        </>
      ) : (
        <>
          <TableContainer
            getRowProps={getRowProps}
            headerGroups={headerGroups}
            getTableBodyProps={getTableBodyProps}
            rows={paginationPageRows}
            getTableProps={getTableProps}
            prepareRow={prepareRow}
            isLoading={isLoading}
            totalRecords={totalRecords}
            tableData={tableData}
            isPatientReportColor={isPatientReportColor}
            showPaymentModeFooter={showPaymentModeFooter}
            showColumns={showColumns}
          />
          {tableData.length !== 0 && showPagination && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              loadPreviousPage={loadPreviousPage}
              loadNextPage={loadNextPage}
              disablePrev={disablePrev}
              disableNext={disableNext}
              disableFirst={disableFirst}
              disableLast={disableLast}
              loadFirstPage={loadFirstPage}
              loadLastPage={loadLastPage}
            />
          )}
        </>
      )}
    </>
  );
}

export default Table;
